import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  "@keyframes fadeIn": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "25%": {
      transform: "rotate(5deg)"
    },
    "50%": {
      transform: "rotate(0deg)"
    },
    "75%": {
      transform: "rotate(-5deg)"
    },
    "100%": {
      transform: "rotate(0deg)"
    }
  },
  "@keyframes l6": {
    "100%": { inset: 0 }
  },
  container: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  loaderAndImg: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1.5rem",
    "& img,svg": {
      width: "120px",
      height: "40px",
      maxWidth: "120px",
      minHeight: "40px",
      animation: "$fadeIn 0.7s ease-in-out 0s infinite"
    }
  },
  loader: {
    width: "120px",
    height: "12px",
    borderRadius: "20px",
    color: theme?.palette?.secondaryBG?.main,
    border: "2px solid",
    position: "relative",
    "&::before": {
      // eslint-disable-next-line quotes
      content: '""',
      position: "absolute",
      margin: "2px",
      inset: "0 100% 0 0",
      borderRadius: "inherit",
      background: theme?.palette?.primaryText?.[100],
      animation: "$l6 2s ease-in-out 0s infinite"
    }
  }
}));
